const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_URL;
const GOOGLE_MAP_URL = 'https://www.google.co.in/maps/preview';
const GOOGLE_PLACE_API =
  'https://maps.googleapis.com/maps/api/place/autocomplete/json';

const AUTH_API_URLS = {
  login: '/users/identify/',
  logout: '/accounts/logout/',
  REGISTER_AGENT: '/users/agents/',
  REGISTER_RENTER: '/users/renters/',
  REGISTER_LANDLORD: '/users/landlords/',
  DELETE_USER: '/accounts/delete/',
  EDIT_RENTER: '/users/renters/#RENTER_ID#/',
  EDIT_AGENT: '/users/agents/#AGENT_ID#/',
  EDIT_LANDLORD: '/users/landlords/#LANDLORD_ID#/',
  CHECK_EMAIL: '/users/email-check/',
  CHECK_PHONE: '/users/phone-check/',
  SEND_OTP: '/accounts/send_otp_phone_number/',
  UPDATE_PHONE_NUMBER: '/users/phone_number_update/',
  GET_SUBSCRIPTION_PLANS: '/users/subscription_plans/',
  APPLY_COUPON: '/users/subscription/apply_coupon/',
  CREATE_AGENT_SUBSCRIPTION: '/users/subscriptions/',
  CANCEL_AGENT_SUBSCRIPTION: '/users/subscription/cancel/',
  GET_UNLIMITED_ACCESS_TOKEN: '/accounts/verify/delimit_token/',
  GET_FAIR_HOUSING_TEMPLATE: '/users/fairhousing/',
  LOGIN_WITH_GOOGLE: '/accounts/oauth/google/sign-in/',
  LOGIN_WITH_APPLE: '/accounts/oauth/apple/sign-in/',
  SEND_PHONE_OTP: '/accounts/send-otp/',
  LOGIN_PHONE_OTP: '/accounts/login-phone-otp/',
  LOGIN_EMAIL_OTP: '/accounts/login-email-otp/',
  VERIFY_LOGIN_EMAIL_OTP: '/accounts/verify-login-email-otp/',
  VERIFY_OTP: '/accounts/verify_otp_phone_number/',
  VERIFY_LOGIN_PHONE_OTP: '/accounts/verify-login-phone-otp/',
  SEND_MAGIC_LINK: '/accounts/send-magic-link/',
  VERIFY_MAGIC_LINK: '/accounts/verify-magic-link/',
  VERIFY_OAUTH_OTP: '/accounts/verify-oauth-phone-otp/',
  SIGN_UP_PHONE: '/accounts/signup-phone/',
  SIGN_UP_PHONE_VERIFY: '/accounts/verify-signup-phone-otp/',
  SEND_BASIC_PHONE_OTP: '/accounts/send-basic-phone-otp/',
  COMPLETE_RENTER_SIGNUP: '/accounts/complete-renter-signup/',
  COMPLETE_AGENT_SIGNUP: '/accounts/complete-agent-signup/',
  COMPLETE_LANDLORD_SIGNUP: '/accounts/complete-landlord-signup/',
  SIGNUP_EMAIL_OTP: '/accounts/signup-email-otp/',
  VERIFY_SIGNUP_EMAIL_OTP: '/accounts/verify-signup-email-otp/',
  VERIFY_USER: '/accounts/verify_user/',
  VERIFY_USER_CONFIRM: 'accounts/verify_user_confirm/',
  REQUEST_EMAIL_CHANGE: '/accounts/request-email-change/',
  VERIFY_EMAIL_CHANGE: '/accounts/verify-email-change/',
  REQUEST_PHONE_CHANGE: '/accounts/request-phone-change/',
  VERIFY_PHONE_CHANGE: '/accounts/verify-phone-change/',
  REQUEST_CANCEL_SUBSCRIPTION: '/users/subscription/request-cancel/',
  AGENT_LOOKUP: '/users/agents/lookup/',
};

const PLAID_URLS = {
  GENERATE_TOKEN: '/users/plaidlink/#ID#/',
};

const PROPERTIES_API_URL = {
  PUBLIC_PROPERTIES: '/properties/public/',
  AGENT_PROPERTIES: '/properties/public/listed_by',
  AGENT_PROPERTIES_COUNT: '/properties/public/agent/properties/count/',
  PROPERTY_PREVIEW_BEFORE_POSTING: '/properties/preview/',
  PROPERTY_ID: `/properties/public/#ID#/`,
  MODIFY_PROPERTY_DOCUMENT: `/properties/public/#ID#/documents/modify/`,
  MAP_DATA: '/properties/public/map',
  OPEN_PROPERTY: '/properties/public/#ID#/open/',
  CLOSE_PROPERTY: '/properties/public/#ID#/close/',
  GET_ALL_SAVE_PROPERTY: '/savesrenter/',
  POST_RENTER_SAVE_SYNC: '/savesrenter/sync/',
  DELETE_RENTER_SAVE_SYNC: '/savesrenter/',
  SEARCH_PROPERTY: '/users/place/search/',
  AGENT_TEMPLATE_RETREIVE: '/users/agents/property/template/',
  AGENT_DOCUMENTS: '/users/agents/property/documents/',
  CHECK_DUPLICATE_DOCUMENT: 'users/agent/custom/document/name/check/',
  DELETE_DOCUMENT: '/users/agent/custom/document/delete/',
  AGENT_CLOSE_PROPERTY: '/properties/public/#ID#/finalize/',
  GET_LANDLORD_ATTESTATIONS:
    '/applications/public/transunion/landlord/attestations/#PROPERTY_ID#',
  ACCEPT_LANDLORD_ATTESTATIONS:
    '/applications/public/transunion/landlord/attestations/accept/',
  INVITE_COLLABORATORS: '/properties/#ID#/collaborators/invite/',
  UPDATE_COLLABORATOR_ROLE:
    '/properties/#PROPERTY_ID#/collaborators/#COLLABORATOR_ID#/update-role/',
  REMOVE_COLLABORATOR:
    '/properties/#PROPERTY_ID#/collaborators/#COLLABORATOR_ID#/remove/',
  RESEND_COLLABORATOR_INVITE:
    '/properties/#PROPERTY_ID#/collaborators/#COLLABORATOR_ID#/resend/',
  MY_COLLABORATIONS: '/properties/collaborations/my/',
  LEAVE_COLLABORATION: '/properties/collaborations/leave/#PROPERTY_ID#/',
  ACCEPT_COLLABORATION: '/properties/collaborations/invite/accept/',
  REJECT_COLLABORATION: '/properties/collaborations/invite/reject/',
};

const APPLICATIONS_API_URL = {
  IDENTIFY_PROPERTY_ASSOCIATE_WITH_RENTER:
    '/applications/public/associated_with_renter/#RENTER_ID#/',
  GET_NON_INVITED_APPLICATIONS:
    '/applications/public/associated_with_renter/non-invited/applications/',
  GET_INVITED_APPLICATIONS:
    '/applications/public/associated_with_renter/invited/applications/',
  CREATE_APPLICATION: '/applications/public/',
  IDENTIFY_PROPERTY_ASSOCIATE_WITH_AGENT:
    '/applications/public/for_agent/#AGENT_ID#/for_property/#PROPERTY_ID#/',
  GET_AGENT_APPLICATIONS_COUNT:
    '/applications/public/agent/applications/count/property/#PROPERTY_ID#/',
  VERIFY_DOCUMENT_RENTER:
    '/applications/public/#APPLICATION_ID#/for_renter/#RENTER_ID#/verify/',
  PUBLIC_PROPERTIES: '/properties/public/',
  AGENT_PROPERTIES: '/properties/public/listed_by/',
  PROPERTY_DESCRIPTION: '/properties/description/',
  ATTACH_DOCUMENTS_TO_APPLICATION:
    '/applications/public/#APPLICATION_ID#/for_renter/#RENTER_ID#/upload_documents/',
  SUBMIT_APPLICATION_RENTER:
    '/applications/public/#APPLICATION_ID#/for_renter/#RENTER_ID#/lock-in',
  APPLICATION_CHECKOUT_VIEW: '/applications/public/#APPLICATION_ID#/pay',
  GET_SINGLE_APPLICATION: '/applications/public/#APPLICATION_ID#/',
  GET_DOCUMENT_SIGN_SIGNING_SESSION:
    '/applications/public/#APPLICATION_ID#/for_renter/#RENTER_ID#/sign/',
  CREATE_SEND_LEASE_SESSION:
    '/applications/public/#APPLICATION_ID#/send-lease/',
  ACCEPT_APPLICATION_BY_AGENT:
    '/applications/public/#APPLICATION_ID#/for_agent/#AGENT_ID#/accept/',
  DENY_APPLICATION_BY_AGENT:
    '/applications/public/#APPLICATION_ID#/for_agent/#AGENT_ID#/deny/',
  CANCEL_APPLICATION_BY_RENTER:
    '/applications/public/#APPLICATION_ID#/for_renter/#RENTER_ID#/cancel/',
  NOTIFY_SIGN_LEASE: '/applications/public/#APPLICATION_ID#/notify_sign_lease/',
  FINIX_PAYMENT_SESSION: '/applications/public/#APPLICATION_ID#/pay/',
  FAKE_FINIX_PAYMENT_SESSION: '/applications/public/test_pay',
  TU_GENERATE_SCREENING_SESSION:
    '/applications/public/transunion/generate/screening_request/#APPLICATION_ID#',
  TU_GENERATE_SCREENING_QUESTIONS:
    '/applications/public/transunion/generate/questions/#APPLICATION_ID#/#SCREENING_ID#',
  TU_SCREENING_ANSWER_SESSION:
    '/applications/public/transunion/answer/#EXAM_ID#',
  GET_RENTER_ATTESTATIONS:
    '/applications/public/transunion/renter/attestations/#SCREENING_ID#',
  ACCEPT_RENTER_ATTESTATIONS:
    '/applications/public/transunion/renter/attestations/accept/',
  FETCH_INVITE_TOKEN_DETAILS:
    '/applications/public/invite/validate/?token=#INVITE_TOKEN#',
  ADD_CO_APPLICANT: `/applications/public/#APPLICATION_ID#/add_coapplicants/`,
  DELETE_CO_APPLICANT: `/applications/public/#APPLICATION_ID#/delete_coapplicant/#IDENTIFIER#`,
  ACCEPT_CO_APPLICANT_INVITE:
    '/applications/public/application/#APPLICATION_ID#/invite/accept/',
  REJECT_CO_APPLICANT_INVITE:
    '/applications/public/application/#APPLICATION_ID#/invite/reject/',
  GET_AGENT_DOCUMENTS_PDF:
    '/applications/public/application/#APPLICATION_ID#/generate/pdf/',
  GET_AGENT_DOCUMENTS_PDF_PER_APPLICANT:
    '/applications/public/application/#APPLICATION_ID#//applicant/#APPLICANT_ID#/generate/pdf/',
  REORDER_DOCUMENTS: `/applications/public/reorder/documents/`,
  FINIX_GENERATE_APPLE_SESSION: '/applications/public/apple_pay_session',
  SKIP_LEASE: '/applications/public/#APPLICATION_ID#/manual-lease-sign/',
  GET_CRM_APPLICATIONS: '/applications/public/agent/crm/applicants/',
  REOPEN_APPLICATION:
    '/applications/public/application/#APPLICATION_ID#/reopen/',
  RESEND_EMAIL_FOR_APPLICANT:
    '/applications/#APPLICATION_ID#/applicant/resend_invite/',
  GET_AGENT_CUSTOM_TEMPLATE_FOR_APPLICANT:
    'users/renter/application/template/#APPLICATION_ID#/',
  SAVE_RENTER_CUSTOM_TEMPLATE_FOR_APPLICANT:
    'users/renter/application/template/#APPLICATION_ID#/',
  UPDATE_APPLICATION: '/applications/public/#APPLICATION_ID#/',
  CREDIT_BYPASS:
    'applications/public/application/#APPLICATION_ID#/applicant/#APPLICANT_ID#/credit_bypass/',
  GET_RENTER_TRANSUNION_INFORMATION: 'users/renter/transunion/fetch',
  GET_TRANSUNION_STATE_LIST: 'applications/public/transunion/states/',
  UPDATE_RENTER_TRANSUNION_INFORMATION: '/users/renter/transunion/update',
  REVERT_CREDIT_BYPASS:
    'applications/public/application/#APPLICATION_ID#/applicant/#APPLICANT_ID#/revert_credit_bypass/',
  GET_RENTER_APPLICATIONS: '/applications/public/agent/crm/#RENTER_ID#/',
  GET_NYLAS_SESSION: '/users/nylas/authorization/',
  SET_NYLAS_CODE: '/users/nylas/callback/',
  GET_NYLAS_CONNECTION: '/users/nylas/validity_check/',
  GET_MARKETING_CRM_APPLICANTS: '/users/marketing/crm/fetch',
  GET_MARKETING_CRM_ANALYTICS: '/users/marketing/crm/analytics/',
  GET_MARKETING_CRM_APPLICATIONS: '/users/marketing/crm/detail/#MAIL_USER_ID#/',
  GET_APPLICATION_CRM_ANALYTICS: '/applications/public/agent/crm/analytics',
  DELETE_NYLAS_CONNECTION: '/users/nylas/delete/',
  ACCEPT_REQUEST_APPLICATION:
    '/applications/public/application/#APPLICATION_ID#/accept_request/',
  GET_CRM_SAMPLE_DOWNLOAD: '/users/marketing/crm/sample/download/',
  GET_CRM_FIELD_LIST: '/users/marketing/crm/mapping/fields/',
  UPLOAD_FILE_AND_MAP_FIELDS: '/users/marketing/crm/leads/file/upload/',
  GET_JOBS_HISTORY: '/users/marketing/crm/leads/file/history/',
  GET_APPLICATION_TAGS: 'users/agent/tags/',
  CREATE_AGENT_TAGS: 'users/agent/tags/',
  SAVE_RENTER_TAGS: 'users/agent/apply/tag/',
  GET_TAG_COUNT: 'users/agent/tag/#tagId#/count/',
  DELETE_AGENT_TAGS: 'users/agent/tags/#tagId#/',
  CHECK_RENTER_INVITE: '/applications/public/renter/invite/check/',
  AGENT_ACCESS_BACKGROUND:
    '/applications/public/applicant/conditional_lease/validate/#APPLICANT_ID#',
  GET_ONE_OFF_CRM_APPLICATIONS: '/applications/oneoff/credit/agent/list/',
  UPLOAD_APPLICATION_DOCUMENTS:
    '/applications/public/#APPLICATION_ID#/upload_documents',
  DELETE_APPLICATION_DOCUMENT:
    '/applications/#APPLICATION_ID#/applicant/#APPLICANT_ID#/document/#DOCUMENT_ID#/delete/',
};

const ADDRESS_API_URL = {
  ADDRESS_AUTCOMPLETE: '/properties/autocomplete/',
  OFFICE_COMMUTE: '/properties/public/distance_from/', // :property_id
  SEARCH_AUTOCOMPLETE: 'properties/autocomplete_location_search/',
};

const LANDLORD_URLS = {
  GET_PROFILE: 'users/landlords/#ID#/',
};

const AGENT_URLS = {
  GET_PROFILE: 'users/agents/#ID#/',
  AGENT_PUBLIC_PROFILE: 'users/public/profile/#ID#/',
  FETCH_TRANSACTION_HISTORY: 'users/subscription/transactions/',
  FETCH_UPCOMING_PAYMENTS: 'users/subscription/upcoming_payments/',
  UPDATE_TRANSACTION_CARD: 'users/finix_identity/update/',
  ADD_TRANSACTION_CARD: 'users/finix_identity/create/',
};

const RENTER_URLS = {
  GET_PROFILE: 'users/renters/#ID#/',
  UPDATE_PROFILE: 'users/renters/#ID#/',
  SAVE_DOCUMENTS: 'users/documents/',
  GET_DOCUMENTS: 'users/documents/',
  SIGN_FAIR_HOUSING: 'users/fairhousing/sign/',
  GET_IS_RENTER_ALREADY_SIGN_FAIR_HOUSING_FORM: 'users/fairhousing/status/',
};

const CHAT_API_URL = {
  GET_ROOMS: '/messaging/rooms/',
  GET_ROOM_MESSAGES: '/messaging/public/for_room/#ID#',
  GET_EXISTING_ROOM: '/messaging/rooms/get_room/',
  CREATE_MESSAGE: '/messaging/public/',
  CREATE_MESSAGE_ROOM: '/messaging/rooms/',
  UPDATE_ROOM: '/messaging/rooms/#ROOM_ID#/',
  GET_USER_HAS_UNREAD_MSGS: '/messaging/public/has_unreads',
  REMOVE_LINKED_PROPERTY:
    '/messaging/public/for_room/#ROOM_ID#/delete_linked_propery/#PROPERTY_ID#',
  GET_FAIR_HOUSING_PROPOSAL_EXIST:
    '/messaging/public/for_room/#ROOM_ID#/fair_housing/exists_request/',
};

const PASSWORD = {
  PASSWORD_RESET: '/accounts/password_reset/',
  PASSWORD_CONFIRM: '/accounts/password_reset_confirm/',
  PASSWORD_RESET_TOKEN: '/accounts/password_reset_valid_token/',
};

const VERIFY = {
  VERIFY_EMAIL: '/accounts/verify_user_valid_token/',
  VERIFY_USER_CONFIRM: '/accounts/verify_user_confirm/',
  VERIFY_EMAIL_VIEW: '/accounts/verify_user/',
};

const ONE_OFF_CREDIT = {
  SEND_OTP: '/applications/public/oneoff/otp/send/',
  VERIFY_OTP: '/applications/public/oneoff/otp/verify/',
  FINIX_PAYMENT_SESSION: '/applications/public/oneoff/credit/pay/',
  TU_GENERATE_SCREENING_SESSION: 'applications/public/oneoff/credit/generate/',
  ENABLE_BACKGROUND_CHECK:
    '/applications/oneoff/credit/#APPLICATION_ID#/enable_background/',
  CREDIT_CHECK_STATUS:
    '/applications/oneoff/credit/application/#APPLICATION_ID#/status/',
};

export {
  API_BASE_URL,
  APP_BASE_URL,
  GOOGLE_MAP_URL,
  GOOGLE_PLACE_API,
  AUTH_API_URLS,
  PROPERTIES_API_URL,
  ADDRESS_API_URL,
  PLAID_URLS,
  AGENT_URLS,
  RENTER_URLS,
  LANDLORD_URLS,
  APPLICATIONS_API_URL,
  CHAT_API_URL,
  PASSWORD,
  VERIFY,
  ONE_OFF_CREDIT,
};
